import { type AxiosInstance, HttpStatusCode, isAxiosError } from "axios";
import { type SansanConnectionResponse } from "@/features/sansanIntegration/types";

export const SANSAN_CONNECTION_ENDPOINT = "/sansan/connection/";

/**
 * Sansan連携を取得する（`GET /sansan/connection/`）。
 * 未連携の場合はAPIが404を返すため、エラーではなく`null`として返す。
 */
export const getConnection = async (
  apiClient: AxiosInstance
): Promise<SansanConnectionResponse | null> => {
  try {
    const { data } = await apiClient.get<SansanConnectionResponse>(
      SANSAN_CONNECTION_ENDPOINT
    );
    return data;
  } catch (error) {
    if (
      isAxiosError(error) &&
      error.response?.status === HttpStatusCode.NotFound
    ) {
      return null;
    }
    throw error;
  }
};
